import { render, staticRenderFns } from "./SignUpPrivacyPolicy.vue?vue&type=template&id=574cfade&scoped=true"
import script from "./SignUpPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./SignUpPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./SignUpPrivacyPolicy.vue?vue&type=style&index=0&id=574cfade&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574cfade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574cfade')) {
      api.createRecord('574cfade', component.options)
    } else {
      api.reload('574cfade', component.options)
    }
    module.hot.accept("./SignUpPrivacyPolicy.vue?vue&type=template&id=574cfade&scoped=true", function () {
      api.rerender('574cfade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/SignUpPrivacyPolicy.vue"
export default component.exports